import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "button", "fileInput", "filePreview", "fileName", "buttonWrapper"];

  connect() {
    this.checkUploadButtonState();
  }

  checkUploadButtonState() {
    const fileInputs = this.element.querySelectorAll('input[type="file"]');
    const hasFiles = Array.from(fileInputs).some(input => input.files.length > 0);
    this.buttonTarget.disabled = !hasFiles;
  }

  handleFileChange(event) {
    const input = event.target;
    const fieldId = input.id;
    const buttonWrapper = document.getElementById(`${fieldId}_button_wrapper`);
    const preview = document.getElementById(`${fieldId}_file_preview`);
    const fileNameSpan = document.getElementById(`${fieldId}_file_name`);

    if (input.files.length > 0) {
      fileNameSpan.textContent = input.files[0].name;
      buttonWrapper.classList.add('hidden');
      preview.classList.remove('hidden');
    }

    this.checkUploadButtonState();
  }

  resetFile(event) {
    const button = event.target;
    const fieldId = button.closest('[id$="_file_preview"]').id.replace('_file_preview', '');
    const input = document.getElementById(fieldId);
    const buttonWrapper = document.getElementById(`${fieldId}_button_wrapper`);
    const preview = document.getElementById(`${fieldId}_file_preview`);
    const fileNameSpan = document.getElementById(`${fieldId}_file_name`);

    input.value = '';
    fileNameSpan.textContent = '';
    preview.classList.add('hidden');
    buttonWrapper.classList.remove('hidden');

    this.checkUploadButtonState();
  }
} 